import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Props = {
  id?: string | number,
  checked: boolean,
  onChange: { (e: any): void },
};

const Switch = ({
  id,
  checked,
  onChange,
  ...rest
}: Props) => (
  <Flex>
    <S.Label htmlFor={id}>
      <S.Input
        {...rest}
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <S.Lever />
    </S.Label>
  </Flex>
);

export default Switch;
